"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseLanguage = exports.isLanguage = exports.getSupportedLanguages = exports.Language = void 0;
const Subsidiary_1 = require("./Subsidiary");
exports.Language = {
    DUTCH: 'nl',
    ENGLISH: 'en',
    FRENCH: 'fr',
    GERMAN: 'de',
};
const getSupportedLanguages = (subsidiary) => {
    switch (subsidiary) {
        case Subsidiary_1.Subsidiary.NL:
            return [exports.Language.DUTCH, exports.Language.ENGLISH];
        case Subsidiary_1.Subsidiary.BE:
            return [exports.Language.DUTCH, exports.Language.FRENCH, exports.Language.ENGLISH];
        case Subsidiary_1.Subsidiary.DE:
            return [exports.Language.GERMAN, exports.Language.ENGLISH];
        default:
            return [];
    }
};
exports.getSupportedLanguages = getSupportedLanguages;
const isLanguage = (value) => Object.values(exports.Language).some((language) => language === value);
exports.isLanguage = isLanguage;
const parseLanguage = (value) => {
    const lowercaseValue = value.toLowerCase();
    return (0, exports.isLanguage)(lowercaseValue) ? lowercaseValue : undefined;
};
exports.parseLanguage = parseLanguage;
